var map = {
	"./asset_BTC.svg": "5012",
	"./asset_ETH-SOL.png": "a50f",
	"./asset_ETH-USDC.png": "53ae",
	"./asset_ETH.svg": "8523",
	"./asset_FIDA.svg": "9b66",
	"./asset_FTT.svg": "3d88",
	"./asset_GMT.svg": "2d4f",
	"./asset_GST.svg": "6d3d",
	"./asset_JSOL.svg": "1471",
	"./asset_LARIX.svg": "c1fa",
	"./asset_LARIX@2x.png": "5652",
	"./asset_LDO.svg": "3ea5",
	"./asset_MNDE.svg": "e508",
	"./asset_RAY-SOL.png": "395a",
	"./asset_RAY-USDC.png": "d567",
	"./asset_RAY-USDT.png": "013c",
	"./asset_RAY-soETH.png": "f25b",
	"./asset_RAY.svg": "2f68",
	"./asset_SOL-USDC.png": "2468",
	"./asset_SOL-USDT.png": "35e3",
	"./asset_SOL.svg": "99ba",
	"./asset_SRM.svg": "7b21",
	"./asset_STEP.svg": "eeed",
	"./asset_USDC.svg": "be16",
	"./asset_USDT.svg": "077f",
	"./asset_UST.svg": "a061",
	"./asset_mSOL-USDC.png": "4f08",
	"./asset_mSOL-USDT.png": "cb00",
	"./asset_mSOL.svg": "8c07",
	"./asset_scnSOL.svg": "71cf",
	"./asset_soETH.svg": "84ab",
	"./asset_soFTT.svg": "fa78",
	"./asset_stSOL.svg": "5a48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc4f";